import type { CSSProperties } from 'react';
import { DELIVERED_STATUS_ID, type Delivery, type DeliveryBoardStatus } from '@interfaces/ILogistics';
import { isOverdueOn } from './board.logic';

const IN_FLIGHT_TONES = ['var(--g400)', 'var(--info)', 'var(--ops-select-edge)', 'var(--avatar-fg-1)'];
/** Delivered, not synced yet: the drawer's Not synced pill. */
export const DELIVERED_TONE = 'var(--amber)';
/** Delivered and synced: the drawer's Synced pill green. */
export const SYNCED_TONE = 'var(--color-success)';
/** Past its due date and not here: the drawer's overdue pill red. */
export const OVERDUE_TONE = 'var(--color-error)';

/** A column's color, the same on the calendar's chips and legend and on the
 *  delivery drawer's status pill. Sites name their own columns, so a tone follows
 *  the column's place on the board; Delivered is the one fixed meaning. An order
 *  can still name a column the site has since deleted: it reads as the first. */
export function statusTone(statusId: string, statuses: DeliveryBoardStatus[]): string {
  if (statusId === DELIVERED_STATUS_ID) return DELIVERED_TONE;
  const place = statuses.filter((status) => !status.system).findIndex((status) => status.id === statusId);
  return IN_FLIGHT_TONES[Math.max(place, 0) % IN_FLIGHT_TONES.length]!;
}

/** An order's color on the site's `today`: red while it is late, green once synced, else its column's. */
export function orderTone(delivery: Delivery, statuses: DeliveryBoardStatus[], today: string): string {
  if (isOverdueOn(delivery, today)) return OVERDUE_TONE;
  return delivery.isSynced ? SYNCED_TONE : statusTone(delivery.status, statuses);
}

/** The custom property the calendar's chips, cards and legend, and the drawer's pill, paint from. */
export const toneStyle = (tone: string) => ({ '--order-tone': tone }) as CSSProperties;
